import React, { useMemo } from 'react';
import { View } from 'react-native';
import { useTheme } from '../../../src/theme/useTheme';
import { Skeleton } from '../../ui/Skeleton/Skeleton';
import { MatchHubHeroBackground } from '../MatchHubHero/MatchHubHeroBackground';
import { getMatchHubSkeletonStyles } from './MatchHubSkeleton.styles';

export const MatchHubSkeleton: React.FC = () => {
  const theme = useTheme();
  const styles = useMemo(() => getMatchHubSkeletonStyles(theme), [theme]);

  return (
    <View style={styles.root} testID="match-hub-skeleton">
      <View style={styles.content}>
      <View style={styles.hero}>
        <MatchHubHeroBackground />
        <View style={styles.topBar}>
          <Skeleton width={40} height={40} borderRadius={20} />
          <View style={styles.topBarCenter}>
            <Skeleton width={140} height={14} borderRadius={6} />
            <Skeleton width={80} height={10} borderRadius={4} />
          </View>
          <View style={styles.topBarSpacer} />
        </View>

        <View style={styles.kitsRow}>
          <View style={styles.kitSlot}>
            <Skeleton width={42} height={42} borderRadius={8} />
          </View>
          <View style={styles.centerLane}>
            <Skeleton width={60} height={12} borderRadius={6} />
            <Skeleton width={90} height={34} borderRadius={6} />
          </View>
          <View style={styles.kitSlot}>
            <Skeleton width={42} height={42} borderRadius={8} />
          </View>
        </View>

        <View style={styles.namesRow}>
          <View style={styles.nameSide}>
            <Skeleton width={80} height={12} borderRadius={4} />
          </View>
          <View style={styles.nameCenterSlot}>
            <Skeleton width={50} height={12} borderRadius={4} />
          </View>
          <View style={styles.nameSide}>
            <Skeleton width={80} height={12} borderRadius={4} />
          </View>
        </View>
      </View>

      <View style={styles.tabBar}>
        <View style={[styles.tabPill, styles.tabPillActive]} />
        <View style={styles.tabPill} />
        <View style={styles.tabPill} />
        <View style={styles.tabPill} />
      </View>

      <View style={styles.cards}>
        <Skeleton width="100%" height={80} borderRadius={12} />
        <Skeleton width="100%" height={100} borderRadius={12} />
        <Skeleton width="100%" height={110} borderRadius={12} />
        <Skeleton width="100%" height={90} borderRadius={12} />
      </View>
      </View>
    </View>
  );
};
